module.exports = __webpack_public_path__ + "static/img/keti.0a4dac16.png";